import type { RootState } from 'reducers/types';

export const getOrderTemplate = (state: RootState) => {
  const { orderTemplate } = state;

  return orderTemplate;
};

export const getRecurringConfigurationIdFromMetadata = (state: RootState) => {
  const {
    orderTemplate: { metadata: { recurringConfigurationId } = {} } = {},
  } = state;

  return recurringConfigurationId;
};
